import { cross, dot, norm, sub } from "./vec3";

// Keep boundaries and creases; triangulation diagonals are not physical edges.
// The input triangles remain untouched for ray casting and shading.
export function meshEdgeMasks(mesh) {
  const edges = new Map(), masks = [];
  const key = (p) => [p.x, p.y, p.z].map((n) => Math.round(n * 100000)).join(",");
  for (let t = 0; t < (mesh?.length || 0); t += 9) {
    const points = [0, 3, 6].map((i) => ({ x: mesh[t + i], y: mesh[t + i + 1], z: mesh[t + i + 2] }));
    const normal = norm(cross(sub(points[1], points[0]), sub(points[2], points[0])));
    masks[t / 9] = [true, true, true];
    points.forEach((p, i) => {
      const edge = [key(p), key(points[(i + 1) % 3])].sort().join("|");
      if (!edges.has(edge)) edges.set(edge, []);
      edges.get(edge).push({ triangle: t / 9, side: i, normal });
    });
  }
  edges.forEach((faces) => {
    if (faces.length === 2 && dot(faces[0].normal, faces[1].normal) > 1 - 1e-5) {
      faces.forEach(({ triangle, side }) => { masks[triangle][side] = false; });
    }
  });
  return masks;
}
